import globals from '../globals';
export default {
    data() {
        return {
            warning_msg:"",
        }
    },
    components: {
        globals
    },
    methods: {
        /*Create Business Contact */
        async createBusinessContact(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/contacts/business", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        // this.warning_msg = response.data.reason
                        // this.$refs.warning_modal.open();
                        // setTimeout(() => {
                        //     this.$refs.warning_modal.close();
                        // }, 3000);
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                    // this.warning_msg = error.response.data.reason
                    // this.$refs.warning_modal.open();
                    // setTimeout(() => {
                    //     this.$refs.warning_modal.close();
                    // }, 3000);
                }
            })
        },
        /*Edit Business Contact */
        async editBusinessContact(id,params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/contacts/business/"+id, params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        /*Get Business Contact Details */
        async getBusinessContactDetails(id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + "/contacts/business/"+id);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /*Delete Business Contact */
        async deleteBusinessContact(id,params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + "/contacts/business/"+id,{data: params});
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /*List Business Contacts */
        async getBusinessConatactList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/contacts/business/list", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){

                }
            })
        },
        /*List Business Contacts Dropdown */
        async getBusinessContactDropdown(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/contacts/business/dropdown", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){

                }
            })
        },
        /*Create Personal Contact */
        async createPersonalContact(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/contacts/personal", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        /*Edit Personal Contact */
        async editPersonalContact(id,params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/contacts/personal/"+id, params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        /*Get Personal Contact Details */
        async getPersonalContactDetails(id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + "/contacts/personal/"+id);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /*Delete Personal Contact */
        async deletePersonalContact(id,params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + "/contacts/personal/"+id,{data: params});
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /*List Personal Contacts */
        async getPersonalConatactList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/contacts/personal/list", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){

                }
            })
        },
        /*List Personal Contacts Dropdown */
        async getPersonalContactDropdown(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/contacts/personal/dropdown", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){

                }
            })
        },
        async moveBusinessContacts(id,params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/contacts/business/move/"+id,params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async movePersonalContacts(id,params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/contacts/personal/move/"+id,params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getTerritoryList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/deals/territories?skip=${params.skip}&limit=${params.limit}&search_key=${params.search_key}&hierarchy_level=${params.hierarchy_level}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },

        /************************************************************
         * Notes List View, Add Note, Edit Note and Delete Notes
         ************************************************************/
        async getContactsNotesList(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + `/contacts/business/consultation/note/list`,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getNoteDetailById(id){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/contacts/business/consultation/note/`+id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async addContactNotes(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + `/contacts/business/consultation/note`,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async editContactNotes(id, params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + `/contacts/business/consultation/note/` + id,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async DeleteContactNoteById(id){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + `/contacts/business/consultation/note/` + id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /************************************************************
         * Reminders List View, Add Reminders, Edit Reminders and Delete Reminders
         ************************************************************/
        // async getContactRemindersList(params){
        //     return new Promise(async (resolve, reject) => {
        //         try{
        //             let response = await this.$http.post(globals.CRM_SALES_URL + `/contacts/business/consultation/reminder/list`,params)
        //             if (response.data.status_id == 1) {
        //                 resolve(response.data)
        //             } else {
        //                 reject(response.reason)
        //             }
        //         }
        //         catch(error){
        //             this.warning_msg = error.response.data.reason
        //             this.$refs.warning_modal.open();
        //             setTimeout(() => {
        //                 this.$refs.warning_modal.close();
        //             }, 3000);
        //         }
        //     })
        // },
        async getContactRemindersList(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_EMAIL_URL + `/reminders/contacts/list`,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async addContactReminders(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + `/contacts/business/consultation/reminder`,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async editContactReminders(reminder_id,params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + `/contacts/business/consultation/reminder/` + reminder_id, params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async GetContactRemindersDetails(reminder_id){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/contacts/business/consultation/reminder/` + reminder_id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async deleteContactRemindersDetails(reminder_id, rec_id, delete_type){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_EMAIL_URL + `/reminders/delete?id=${reminder_id}&product_name=CRM&recurring_id=${rec_id}&delete_type=${delete_type}`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /************************************************************
         * Meeting List View, Add Meetings, Edit Meetings and Delete Meetings
         ************************************************************/
        async getContactsMeetingList(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_EMAIL_URL + `/reminders/meeting/contacts/list?product_name=CRM`,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async addContactsMeeting(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + `/contacts/business/consultation/meeting`,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async editContactsMeeting(id, params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + `/contacts/business/consultation/meeting/` + id,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async getContactsMeetingDetails(id){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/contacts/business/consultation/meeting/` + id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async deleteContactMeetingDetailsById(id){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + `/contacts/business/consultation/meeting/` + id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /************************************************************
         * Call Report List View, Add Call Report and Remove Call Reports
         ************************************************************/
         async getContactsCallReportList(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + `/contacts/business/consultation/call_report/list`,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async addContactsCallReports(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + `/contacts/business/consultation/call_report`,params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        // async getCallReportsDetailsById(){
        //     return new Promise(async (resolve, reject) => {
        //         try{
        //             let response = await this.$http.delete(globals.CRM_SALES_URL + `/contacts/business/consultation/call_report/`+id)
        //             if (response.data.status_id == 1) {
        //                 resolve(response.data)
        //             } else {
        //                 reject(response.reason)
        //             }
        //         }
        //         catch(error){
        //             this.warning_msg = error.response.data.reason
        //             this.$refs.warning_modal.open();
        //             setTimeout(() => {
        //                 this.$refs.warning_modal.close();
        //             }, 3000);
        //         }
        //     })
        // },
        async deleteContactsCallReports(id){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + `/contacts/business/consultation/call_report/`+id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /*****************************
        Contacts interactions
        ******************************/
        async getContactsInteractionsData(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + `/contacts/business/consultation/interaction`, params)
                    if(response.data.status_id == 1){
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /*****************************
        Check Email Existance
        ******************************/
        async getEmailCheckAPI(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/contacts/business/check_if_email_exist", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async getContactProducts(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/contacts/business/deal/products", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        resolve(response.data)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/contacts.js